<template>
  <div class="m-auto justify-center z-30 fixed inset-x-0 inset-y-0 h-5/6 w-5/6 bg-white rounded-3xl hover:cursor-default">
    <p>HEHEHEHEHEHEHEHEHEHEHEHE</p>
  </div>
</template>

<script>
export default {
  name: 'DatasetViewer'
}
</script>

<style scoped>

</style>
